import { useEffect, useState } from "react";
import { PropTypes } from "prop-types";

function Window({ id = "window-id", children = "content", title = "title", default_opened = false }) {
  const [style, setStyle] = useState({});

  useEffect(() => {
    let info = document.body.getBoundingClientRect();
    let margin = 25;

    let max_width = info.width - 750 - margin;
    let max_height = info.height - 450 - margin - 70 - 20;
    let min_height = margin;
    let min_width = margin;

    let random_position = {
      top: Math.abs(
        Math.floor(Math.random() * (max_height - min_height + 1) + min_height)
      ),
      left: Math.abs(
        Math.floor(Math.random() * (max_width - min_width + 1) + min_width)
      ),
    };

    if (random_position.top <= margin) {
      random_position.top = random_position.top + margin;
    }

    if (info.width <= 750) {
      random_position = {
        top: 0,
        left: 0,
      };
    }

    setStyle({
      top: random_position.top + "px",
      left: random_position.left + "px",
      height: "450px",
      minHeight: "450px",
      width: "750px",
      minWidth: "750px",
    });
  }, []);

  function dragElement(elmnt) {
    // https://www.w3schools.com/howto/howto_js_draggable.asp
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

    elmnt.children[0].onmousedown = dragMouseDown;
    elmnt.onmousedown = function () {
      if (window.increaseZIndex) window.increaseZIndex(elmnt);
    };

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;

      /*if (window.updateTaskbar) updateTaskbar((current) => {
        let article = e.target.parentElement;
        let obj = {
          status: "opened",
          id: article.id,
          name: article.children[0].children[0].outerText,
          selected: true
        };
      return { ...current, [article.id]: obj };
      })*/

    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }

    function closeDragElement(e) {
      let w = e.target.parentElement;
      if (w.localName != "article")
        w = e.target.parentElement.parentElement.parentElement;

      if (w.style.left != "0px" && w.style.top != "0px") {
        let data_saved = {
          top: w.style.top,
          left: w.style.left,
          height: w.style.height,
          width: w.style.width,
        };
        w.setAttribute("data-saved", JSON.stringify(data_saved));
      }
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  useEffect(() => {
    let article = document.getElementById(id.toLowerCase());
    dragElement(article);
    if (window.taskbar && !window.taskbar[id] && default_opened) {
      window.updateTaskbar(id.toLowerCase(), "opened");
    } else {
      window.updateTaskbar(id.toLowerCase(), "closed");
    }
      
  }, []);

  function reduce() {
    if (window.updateTaskbar) window.updateTaskbar(id.toLowerCase(), "reduced");
  }

  function close() {
    if (window.updateTaskbar) window.updateTaskbar(id.toLowerCase(), "closed");
  }

  return (
    <article
      id={id.toLowerCase()}
      style={style}
      data-saved={JSON.stringify(style)}
    >
      <header>
        <h2>
          <img
            onError={(e) => (e.target.src = "./apps-icons/home.svg")}
            alt="window's icon"
            src={"./apps-icons/" + id.toLowerCase() + ".svg"}
          />
          {title}
        </h2>

        <div>
          <button onClick={reduce}>•</button>
          <button onClick={close}>•</button>
        </div>
      </header>

      <content>
        <div>{children}</div>
      </content>
    </article>
  );
}

Window.PropTypes = {
  children: PropTypes.string,
  id: PropTypes.string.isRequired,
  children: PropTypes.element,
};

export default Window;
